import { Context } from '@getaccept/editor-lib';

export class ContentNavigationHelper {
  static scrollToTop = (context: Context.DsrEdit | Context.DsrPublished | Context.DsrTemplate) => {
    let elementId = '';
    switch (context) {
      case Context.DsrEdit:
        elementId = 'edit-view-main-content';
        break;
      case Context.DsrPublished:
        elementId = 'published-view-main-content';
        break;
      case Context.DsrTemplate:
        elementId = 'template-view-main-content';
        break;
    }
    document.getElementById(elementId)?.scrollTo({ top: 0, behavior: 'smooth' });
  };
}
